module.exports = __webpack_public_path__ + "static/media/AboutSlide_2.d5003fb8.png";